<template>
  <div class="view-login auth">
    <div class="logo-wrapper pb-5">
      <img class="logo img-fluid" src="../assets/images/logo-m60-white.svg" />
      <h5 class="mt-4 text-center">
        Seja bem vindo/a ao M60, o preparatório internacional que aprovou mais
        de 45 mil brasileiros em todo o mundo!
      </h5>
    </div>

    <div class="body">
      <div class="row justify-content-center"></div>
      <form @submit.prevent="submit">
        <div class="form-body">
          <h5 class="pt-2 mb-4">Faça seu login</h5>

          <form-group
            v-model="email"
            id="email"
            type="email"
            placeholder="Digite o email cadastrado"
            :errors="errors.email"
          />

          <form-group
            v-model="password"
            id="password"
            type="password"
            placeholder="Digite a sua senha"
            :errors="errors.password"
          />

          <p class="mb-4">
            <a
              href="javascript:void"
              @click="forgotDialog = true"
              class="text-primary btn-forgot"
            >
              Esqueceu sua senha?
            </a>
          </p>

          <button
            class="btn btn-primary btn-block px-5 mt-3"
            type="submit"
            :disabled="loading"
          >
            <loading :show="loading">Entrar</loading>
          </button>
        </div>
      </form>
    </div>

    <forgot-password v-model="forgotDialog" />
  </div>
</template>

<script>
import ForgotPassword from "@/components/login/ForgotPassword";
export default {
  name: "login",
  components: {
    ForgotPassword
  },
  data() {
    return {
      email: "",
      password: "",
      errors: {
        email: null,
        password: null,
        non_field_errors: null
      },
      loading: false,
      forgotDialog: false
    };
  },
  methods: {
    submit() {
      this.$message.hide();

      this.loading = true;

      this.$store
        .dispatch("user/login", {
          email: this.email,
          password: this.password
        })
        .then(() => {
          this.$router.replace({ name: "home" });
        })
        .catch(error => {
          this.errors = error.response.data;
          if (this.errors.non_field_errors) {
            this.$message.error(this.errors.non_field_errors[0]);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.view-login {
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  justify-content: center;
  background: url(../assets/images/login-bg.jpg);
  background-size: cover;

  @media screen and (max-width: 991px) {
    flex-direction: column;
  }

  p {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
  }

  .logo-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: -10vh;

    .logo {
      max-width: 120px;

      @media screen and (max-width: 991px) {
        max-width: 90px;
      }
    }

    h5 {
      max-width: 600px;
      padding: 0px 16px;

      @media screen and (max-width: 575px) {
        font-size: 16px;
      }
    }
  }

  .btn-forgot {
    min-height: 0;
    padding: 0;
    font-weight: bold;
    font-size: 12px;
  }

  a.btn {
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  form {
    display: flex;
    justify-content: center;
    align-items: center;
    .form-body {
      display: flex;
      flex-direction: column;
      width: 420px;

      @media screen and (max-width: 991px) {
        width: 100%;
        padding: 0px 16px;
      }
    }
  }
  ::v-deep.form-control {
    border-radius: 8px;
    height: 48px;
    border: 1px solid #9a9a9a;
    background-color: transparent;
    color: white;
    transition: 0.0001s;
    &::placeholder {
      color: #9a9a9a;
    }
    &:-webkit-autofill,
    &:-webkit-autofill:focus {
      transition: background-color 0s 600000s, color 0s 600000s !important;
    }
  }
}
</style>
